// ============================================
// FORMULES LASERBAY - Configuration centrale
// ============================================
// Ce fichier contient toutes les formules disponibles.
// Pour modifier un prix ou une durée, c'est ici !

// Capacité max par créneau de 30 min
export const MAX_PLAYERS_PER_SLOT = 10;

// Catégories de formules
export const FORMULA_CATEGORIES = {
  INDIVIDUAL: 'individual',
  GROUP: 'group',
  EVENT: 'event'
};

// Labels des catégories (pour l'affichage)
export const CATEGORY_LABELS = {
  [FORMULA_CATEGORIES.INDIVIDUAL]: 'Tarif par personne',
  [FORMULA_CATEGORIES.GROUP]: 'Forfait groupe',
  [FORMULA_CATEGORIES.EVENT]: 'Événement'
};

// Descriptions pédagogiques (affichées sous le nom de catégorie)
export const CATEGORY_DESCRIPTIONS = {
  [FORMULA_CATEGORIES.INDIVIDUAL]: 'Idéal de 1 à 7 joueurs',
  [FORMULA_CATEGORIES.GROUP]: 'Plus avantageux à partir de 9 joueurs (jusqu\'à 10)',
  [FORMULA_CATEGORIES.EVENT]: 'Anniversaire, EVG/EVJF — ambiance festive'
};

// Toutes les formules LaserBay
export const FORMULAS = [
  // ---- INDIVIDUELS ----
  {
    id: 'decouverte',
    name: 'Découverte',
    category: FORMULA_CATEGORIES.INDIVIDUAL,
    price: 12,           // Prix par personne en €
    priceType: 'per_person', // 'per_person' ou 'flat' (prix fixe)
    duration: 30,        // Durée sur place en minutes
    slots: 1,            // Nombre de créneaux de 30 min occupés
    parties: '2 × 10 min',  // Détail des parties
    gameTime: 20,        // Temps de jeu effectif en minutes
    description: '2 parties de 10 min — ~30 min sur place',
    color: '#3b82f6',    // Bleu - pour l'affichage
    icon: '🎯',
    minPlayers: 1,
    maxPlayers: 10
  },
  {
    id: 'aventurier',
    name: 'Aventurier',
    category: FORMULA_CATEGORIES.INDIVIDUAL,
    price: 18,
    priceType: 'per_person',
    duration: 60,
    slots: 2,
    parties: '3 × 10 min',
    gameTime: 30,
    description: '3 parties de 10 min — ~1h sur place',
    color: '#10b981',    // Vert
    icon: '⚔️',
    minPlayers: 1,
    maxPlayers: 10
  },
  {
    id: 'expert',
    name: 'Expert',
    category: FORMULA_CATEGORIES.INDIVIDUAL,
    price: 25,
    priceType: 'per_person',
    duration: 90,
    slots: 3,
    parties: '4 × 12 min',
    gameTime: 48,
    description: '4 parties de 12 min — ~1h30 sur place',
    color: '#8b5cf6',    // Violet
    icon: '🏆',
    minPlayers: 1,
    maxPlayers: 10
  },

  // ---- GROUPES ----
  {
    id: 'groupe_mini',
    name: 'Mini',
    category: FORMULA_CATEGORIES.GROUP,
    price: 100,
    priceType: 'flat',
    duration: 30,
    slots: 1,
    parties: '2 × 10 min',
    gameTime: 20,
    description: '2 parties de 10 min — ~30 min sur place',
    color: '#f59e0b',    // Orange
    icon: '👥',
    minPlayers: 2,
    maxPlayers: 10
  },
  {
    id: 'groupe_medium',
    name: 'Medium',
    category: FORMULA_CATEGORIES.GROUP,
    price: 150,
    priceType: 'flat',
    duration: 60,
    slots: 2,
    parties: '3 × 12 min',
    gameTime: 36,
    description: '3 parties de 12 min — ~1h sur place',
    color: '#f97316',    // Orange foncé
    icon: '👥',
    minPlayers: 2,
    maxPlayers: 10
  },
  {
    id: 'groupe_premium',
    name: 'Premium',
    category: FORMULA_CATEGORIES.GROUP,
    price: 180,
    priceType: 'flat',
    duration: 90,
    slots: 3,
    parties: '4 × 12 min',
    gameTime: 48,
    description: '4 parties de 12 min — ~1h30 sur place',
    color: '#ea580c',    // Orange intense
    icon: '👥',
    minPlayers: 2,
    maxPlayers: 10
  },

  // ---- ÉVÉNEMENTS ----
  {
    id: 'anniversaire',
    name: 'Anniversaire',
    category: FORMULA_CATEGORIES.EVENT,
    price: 160,
    priceType: 'flat',
    duration: 90,
    slots: 3,
    parties: '4 × 12 min',
    gameTime: 48,
    description: '4 parties de 12 min — ~1h30 sur place',
    color: '#ec4899',    // Rose
    icon: '🎂',
    minPlayers: 4,
    maxPlayers: 10
  },
  {
    id: 'evg_evjf',
    name: 'EVG / EVJF',
    category: FORMULA_CATEGORIES.EVENT,
    price: 190,
    priceType: 'flat',
    duration: 90,
    slots: 3,
    parties: '4 × 12 min',
    gameTime: 48,
    description: '4 parties de 12 min — ~1h30 sur place',
    color: '#d946ef',    // Fuchsia
    icon: '🥂',
    minPlayers: 4,
    maxPlayers: 10
  }
];

// ============================================
// HORAIRES D'OUVERTURE
// ============================================

// Créneaux de base (30 min chacun)
const MORNING_SLOTS = ['10:00', '10:30', '11:00', '11:30'];
const AFTERNOON_SLOTS = ['14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00'];

// Tous les créneaux de la journée
export const ALL_SLOTS = [...MORNING_SLOTS, ...AFTERNOON_SLOTS];

// Saison : avril (3) à octobre (9) — chaque année
// Un jour dans la saison PEUT être ouvert (l'admin décide)
// Un jour hors saison ne peut PAS être ouvert
export function isInSeason(date) {
  let d;
  if (typeof date === 'string') {
    // Ajouter T12:00:00 pour éviter le décalage timezone
    d = new Date(date + 'T12:00:00');
  } else {
    d = new Date(date);
  }
  const month = d.getMonth(); // 0-indexed : 3=avril, 9=octobre
  return month >= 3 && month <= 9;
}

// Vérifier si un jour est ouvert
// On regarde dans les sessions Firestore : si au moins un créneau 
// existe et n'est pas marqué "dayClosed", le jour est ouvert.
// Cette fonction est utilisée côté Calendar avec les données chargées.
export function isDayOpen(date, sessions = []) {
  if (!isInSeason(date)) return false;
  
  let dateStr;
  if (typeof date === 'string') {
    dateStr = date;
  } else {
    const d = new Date(date);
    dateStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }
  
  const daySessions = sessions.filter(s => s.date === dateStr);
  
  // Si aucune session n'existe pour ce jour, le jour n'est pas encore configuré
  // → on le considère comme fermé (l'admin doit l'ouvrir)
  if (daySessions.length === 0) return false;
  
  // Si au moins un créneau est ouvert (non bloqué ET marqué isOpen)
  return daySessions.some(s => s.isOpen === true);
}

// Fonction pour obtenir les créneaux disponibles pour une date
// Retourne TOUS les créneaux si on est en saison (l'état ouvert/fermé 
// est géré par chaque session individuellement)
export function getAvailableSlots(date) {
  if (!isInSeason(date)) return [];
  return ALL_SLOTS;
}

// ============================================
// DÉLAI MINIMUM DE RÉSERVATION
// ============================================

// On ne peut pas réserver moins de X minutes avant le début de la session
// Pour changer le délai (2h, 30 min...) : une seule ligne à modifier ici
export const MIN_BOOKING_DELAY_MINUTES = 60;

// Retourne true si le créneau est trop proche dans le temps (ou déjà passé)
export function isSlotTooSoon(date, slot) {
  if (!slot) return false;

  const dateStr = typeof date === 'string'
    ? date
    : `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

  // Heure exacte de début du créneau (heure locale du navigateur)
  const slotDateTime = new Date(`${dateStr}T${slot}:00`);
  if (isNaN(slotDateTime.getTime())) return false;

  // Heure limite = maintenant + délai minimum
  const limite = new Date(Date.now() + MIN_BOOKING_DELAY_MINUTES * 60 * 1000);

  return slotDateTime.getTime() < limite.getTime();
}

// ============================================
// PROMOTIONS
// ============================================

// Liste des promos actives
// Pour ajouter une promo : ajoute un objet dans ce tableau
// Pour désactiver : mets enabled à false ou supprime l'entrée
export const PROMOTIONS = [
  {
    id: 'ouverture-2026',
    name: 'Ouverture de saison -20%',
    description: '-20% sur toutes les formules pour l\'ouverture !',
    discount: 0.20,        // 20% de réduction
    type: 'percentage',     // 'percentage' ou 'fixed'
    dates: ['2026-04-11'],  // Dates concernées (format YYYY-MM-DD)
    formulaIds: null,       // null = toutes les formules, ou ['decouverte', 'aventurier'] pour cibler
    enabled: true
  }
];

// Vérifier si une promo s'applique pour une date et formule données
export function getActivePromo(dateStr, formulaId) {
  return PROMOTIONS.find(promo => {
    if (!promo.enabled) return false;
    if (!promo.dates.includes(dateStr)) return false;
    if (promo.formulaIds && !promo.formulaIds.includes(formulaId)) return false;
    return true;
  }) || null;
}

// Calculer le prix avec promo + tarif dynamique + options
export function calculatePriceWithPromo(formulaId, nbParticipants, dateStr, selectedOptions = []) {
  const formula = getFormulaById(formulaId);
  if (!formula) return { basePrice: 0, finalPrice: 0, promo: null, discount: 0, dynamicSurcharge: null, optionsPrice: 0 };

  // 1. Prix de base
  let basePrice = calculatePrice(formulaId, nbParticipants);
  
  // 2. Tarif dynamique (week-end)
  const dynamic = getDynamicSurcharge(dateStr, formulaId);
  const dynamicTotal = dynamic.surcharge * nbParticipants;
  basePrice += dynamicTotal;
  
  // 3. Promo
  const promo = getActivePromo(dateStr, formulaId);
  let discount = 0;
  if (promo) {
    if (promo.type === 'percentage') {
      discount = Math.round(basePrice * promo.discount * 100) / 100;
    } else {
      discount = promo.discount;
    }
  }
  
  const formulaPrice = Math.max(0, basePrice - discount);
  
  // 4. Options
  const optionsPrice = calculateOptionsPrice(selectedOptions, nbParticipants);
  
  const finalPrice = formulaPrice + optionsPrice;
  
  return { basePrice, finalPrice, promo, discount, dynamicSurcharge: dynamic, optionsPrice, formulaPrice };
}

// ============================================
// TARIFS DYNAMIQUES
// ============================================
// Majoration automatique le week-end et vacances scolaires

export const DYNAMIC_PRICING = {
  enabled: false, // Désactivé — à réactiver quand tu veux
  // Jours de la semaine avec majoration (0=dim, 6=sam)
  weekendDays: [0, 6], // samedi et dimanche
  weekendSurcharge: 2,  // +2€ par personne le week-end (formules individuelles uniquement)
  
  // Périodes de vacances scolaires (zone B - Normandie)
  // Format : [début, fin] en YYYY-MM-DD
  holidayPeriods: [
    ['2026-04-11', '2026-04-27'], // Vacances de printemps
    ['2026-07-04', '2026-08-31'], // Vacances d'été
    ['2026-10-17', '2026-11-02'], // Toussaint
  ],
  holidaySurcharge: 0, // Pas de surcharge vacances pour l'instant (modifie si besoin)
};

// Vérifier si une date est un week-end
export function isWeekend(dateStr) {
  const d = new Date(dateStr + 'T12:00:00');
  return DYNAMIC_PRICING.weekendDays.includes(d.getDay());
}

// Vérifier si une date est en vacances scolaires
export function isHoliday(dateStr) {
  return DYNAMIC_PRICING.holidayPeriods.some(([start, end]) => dateStr >= start && dateStr <= end);
}

// Obtenir la surcharge dynamique pour une date
export function getDynamicSurcharge(dateStr, formulaId) {
  if (!DYNAMIC_PRICING.enabled) return { surcharge: 0, reason: null };
  
  const formula = getFormulaById(formulaId);
  if (!formula || formula.priceType !== 'per_person') return { surcharge: 0, reason: null };
  
  let surcharge = 0;
  let reason = null;
  
  if (isWeekend(dateStr) && DYNAMIC_PRICING.weekendSurcharge > 0) {
    surcharge = DYNAMIC_PRICING.weekendSurcharge;
    reason = `Week-end (+${surcharge}€/pers.)`;
  }
  
  if (isHoliday(dateStr) && DYNAMIC_PRICING.holidaySurcharge > 0) {
    surcharge += DYNAMIC_PRICING.holidaySurcharge;
    reason = surcharge > DYNAMIC_PRICING.weekendSurcharge 
      ? `Vacances & week-end (+${surcharge}€/pers.)` 
      : reason || `Vacances (+${DYNAMIC_PRICING.holidaySurcharge}€/pers.)`;
  }
  
  return { surcharge, reason };
}

// ============================================
// OPTIONS / VENTES ADDITIONNELLES
// ============================================

export const BOOKING_OPTIONS = [
  {
    id: 'photos',
    name: 'Pack photos souvenirs',
    description: 'Photos de votre session envoyées par email',
    price: 5,
    priceType: 'flat', // prix fixe peu importe le nombre
    icon: '📸',
    enabled: false
  },
  {
    id: 'boissons',
    name: 'Pack boissons (par personne)',
    description: '1 boisson fraîche par joueur',
    price: 2,
    priceType: 'per_person', // multiplié par le nombre de joueurs
    icon: '🥤',
    enabled: true
  },
  {
    id: 'tshirt',
    name: 'T-shirt LaserBay',
    description: 'T-shirt souvenir officiel LaserBay',
    price: 15,
    priceType: 'per_unit', // le client choisit la quantité
    icon: '👕',
    enabled: false
  }
];

// Calculer le prix des options sélectionnées
export function calculateOptionsPrice(selectedOptions, nbParticipants) {
  let total = 0;
  for (const opt of selectedOptions) {
    const option = BOOKING_OPTIONS.find(o => o.id === opt.id);
    if (!option || !option.enabled) continue;
    
    if (option.priceType === 'flat') {
      total += option.price;
    } else if (option.priceType === 'per_person') {
      total += option.price * nbParticipants;
    } else if (option.priceType === 'per_unit') {
      total += option.price * (opt.quantity || 1);
    }
  }
  return total;
}

// Obtenir une formule par son ID
export function getFormulaById(formulaId) {
  return FORMULAS.find(f => f.id === formulaId) || null;
}

// Obtenir les formules d'une catégorie
export function getFormulasByCategory(category) {
  return FORMULAS.filter(f => f.category === category);
}

// Calculer le prix total d'une réservation (sans promo)
export function calculatePrice(formulaId, nbParticipants) {
  const formula = getFormulaById(formulaId);
  if (!formula) return 0;

  if (formula.priceType === 'per_person') {
    return formula.price * nbParticipants;
  }
  // Prix forfaitaire
  return formula.price;
}

// Vérifier si des créneaux consécutifs sont disponibles
// startSlot : l'heure de début (ex: '14:00')
// nbSlots : nombre de créneaux nécessaires
// existingSessions : les sessions déjà réservées/bloquées pour ce jour
// Retourne : { available: true/false, slots: ['14:00', '14:30', '15:00'], reason: '' }
export function checkConsecutiveSlots(startSlot, nbSlots, date, existingSessions = [], isAdmin = false) {
  const allSlots = getAvailableSlots(date);
  const startIndex = allSlots.indexOf(startSlot);
  
  // Créneau de départ introuvable
  if (startIndex === -1) {
    return { available: false, slots: [], reason: 'Créneau de départ invalide' };
  }

  // Délai minimum : pas de réservation à moins d'1h du début (admin exempté)
  if (!isAdmin && isSlotTooSoon(date, startSlot)) {
    return {
      available: false,
      slots: [],
      reason: `Réservation impossible à moins de ${MIN_BOOKING_DELAY_MINUTES} min du début de la session`
    };
  }

  // Vérifier qu'il y a assez de créneaux après le créneau de départ
  if (startIndex + nbSlots > allSlots.length) {
    return { 
      available: false, 
      slots: [], 
      reason: 'Pas assez de créneaux disponibles après cette heure (fin de journée ou pause déjeuner)' 
    };
  }

  // Récupérer les créneaux consécutifs nécessaires
  const neededSlots = allSlots.slice(startIndex, startIndex + nbSlots);

  // Vérifier la continuité (pas de saut dû à la pause déjeuner)
  for (let i = 1; i < neededSlots.length; i++) {
    const prevMinutes = slotToMinutes(neededSlots[i - 1]);
    const currMinutes = slotToMinutes(neededSlots[i]);
    if (currMinutes - prevMinutes !== 30) {
      return { 
        available: false, 
        slots: [], 
        reason: 'Les créneaux ne sont pas consécutifs (pause déjeuner entre les deux)' 
      };
    }
  }

  // Vérifier qu'aucun créneau nécessaire n'est bloqué ou fermé
  for (const slot of neededSlots) {
    const session = existingSessions.find(s => s.time === slot);
    
    // Créneau pas encore créé ou fermé
    if (!session || session.isOpen !== true) {
      return { 
        available: false, 
        slots: [], 
        reason: `Le créneau ${slot} n'est pas ouvert` 
      };
    }
    
    // Créneau bloqué par l'admin
    if (session.isBlocked) {
      return { 
        available: false, 
        slots: [], 
        reason: `Le créneau ${slot} est bloqué (${session.blockReason || 'raison non précisée'})` 
      };
    }
  }

  // Vérifier la capacité max sur chaque créneau
  for (const slot of neededSlots) {
    const session = existingSessions.find(s => s.time === slot);
    if (session && (session.participantCount || 0) >= MAX_PLAYERS_PER_SLOT) {
      return { 
        available: false, 
        slots: [], 
        reason: `Le créneau ${slot} est complet (${MAX_PLAYERS_PER_SLOT} joueurs max)` 
      };
    }
  }

  return { available: true, slots: neededSlots, reason: '' };
}

// Convertir un créneau horaire en minutes depuis minuit
function slotToMinutes(slot) {
  const [hours, minutes] = slot.split(':').map(Number);
  return hours * 60 + minutes;
}

// Obtenir les créneaux de départ possibles pour une formule donnée
// Retourne la liste des heures de départ où la formule "rentre"
export function getValidStartSlots(formulaId, date, existingSessions = [], isAdmin = false) {
  const formula = getFormulaById(formulaId);
  if (!formula) return [];

  const allSlots = getAvailableSlots(date);
  const validStarts = [];

  for (const slot of allSlots) {
    const check = checkConsecutiveSlots(slot, formula.slots, date, existingSessions, isAdmin);
    if (check.available) {
      validStarts.push(slot);
    }
  }

  return validStarts;
}

// ============================================
// CARTE FIDÉLITÉ
// ============================================

export const LOYALTY_CONFIG = {
  enabled: true,
  // Paliers de fidélité
  levels: [
    { name: 'Nouveau', minBookings: 0, icon: '🆕', color: '#94a3b8' },
    { name: 'Habitué', minBookings: 3, icon: '⭐', color: '#f59e0b' },
    { name: 'Fidèle', minBookings: 5, icon: '🌟', color: '#8b5cf6' },
    { name: 'VIP', minBookings: 10, icon: '💎', color: '#dc2626' },
  ],
  // Récompense : après X réservations, la Xème est offerte
  freeSessionEvery: 6, // 6ème session gratuite
  freeSessionFormula: 'decouverte', // La formule offerte
};

// Obtenir le niveau de fidélité d'un contact
export function getLoyaltyLevel(totalBookings) {
  const levels = LOYALTY_CONFIG.levels;
  let current = levels[0];
  for (const level of levels) {
    if (totalBookings >= level.minBookings) {
      current = level;
    }
  }
  return current;
}

// Vérifier si le contact a droit à une session gratuite
export function hasFreeSession(totalBookings) {
  if (!LOYALTY_CONFIG.enabled) return false;
  return totalBookings > 0 && totalBookings % LOYALTY_CONFIG.freeSessionEvery === 0;
}

// ============================================
// OCCUPATION EFFECTIVE D'UN CRÉNEAU
// ============================================

// Calcule combien de "places" une réservation occupe réellement sur un créneau.
// La logique :
//  - Formule INDIVIDUELLE (per_person / catégorie 'individual') :
//      on compte le nombre réel de participants
//      (ex: 3 personnes en "Aventurier" = 3 places occupées sur 10)
//
//  - Formule GROUPE ou ÉVÉNEMENT (forfait, privatif) :
//      le créneau est entièrement bloqué (10 places)
//      car le client a payé pour avoir la salle pour lui
//      (ex: un anniversaire à 6 enfants bloque les 10 places)
//
// Cette fonction est utilisée dans dataService.js pour mettre à jour
// correctement le participantCount de chaque session.
export function getEffectiveSlotOccupancy(formula, nbParticipants) {
  // Si pas de formule trouvée, on retombe sur le nombre brut de participants
  if (!formula) return nbParticipants || 0;

  // Formule privative (groupe ou événement) : on bloque toutes les places
  if (formula.category !== FORMULA_CATEGORIES.INDIVIDUAL) {
    return MAX_PLAYERS_PER_SLOT;
  }

  // Formule individuelle : on compte le vrai nombre de joueurs
  return nbParticipants || 0;
}
